import PageContainer from "@/component/pageContainer";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import style from "./index.module.less";
import { trackGdp } from "@/utils/gio-report";
import { teamMemberList, proposer, dropOutOfLine, dissolveTeam } from "./ajax";
import { getCurrentUid } from "@/api/common";
import { Checkbox, Loading, Toast } from "@xp-design/mobile";
import PopUpInfoCom from "@/component/popUpInfoCom";

import SharePanel from "@/component/share-panel";
import { getChannel, getBrowserEnv } from "@/utils/tools";
import { useNavigate, useSearchParams } from "react-router-dom";
import { defineShareInfoInMiniProgram } from "@/utils/share";
import { enhancedSafeChainFind } from "../configPage/utils";
import { processOssImage } from "@/utils/image";
import { appendParamsToUrl, getParamsFromHash } from "@/utils/url";
import { goToPageV2 } from "@/utils/common";
import { PageOriginEnums } from "@/hooks/useConfigPage/useConfigPage";
interface Member {
  memberUid?: string;
  memberUserName?: string;
  memberActivityValue?: string;
  memberTeamRole?: string;
  memberTeamRoleCn?: string;
}

interface TeamRecord {
  activityCode?: string;
  selfTeamCode?: string;
  selfTeamName?: string;
  selfTeamActivityValue?: string;
  selfTeamActivityRank?: string;
  peopleMin?: string;
  peopleMax?: string;
  peopleCount?: string;
  selfTeamRole?: string;
  selfTeamRoleCn?: string;
  memberList?: Member[];
}

interface ApiResponse {
  total: number;
  records: TeamRecord[];
}
// 活动详情
const ActivityDetail = () => {
  const { isWXApp, isMyApp, isXPApp } = getBrowserEnv();
  const PopUpInfoComRef = useRef<HTMLDivElement>(null);
  const [checkValue, setCheckValue] = useState<string[]>([]);
  const [list, setList] = useState<Member[] | undefined>([]);
  const [infoObj, setInfoObj] = useState<TeamRecord>({});
  const SharePanelRef = useRef<any>(null);
  const pageOrigin = getParamsFromHash("pageOrigin") || "";
  const isNotOver = useMemo(() => getParamsFromHash("isOver") == "false", []);
  const hdFontVal = useMemo(() => getParamsFromHash("hdFontVal"), []);
  const pageCode = useMemo(() => getParamsFromHash("pageCode") || "", []);
  const moduleId = useMemo(() => getParamsFromHash("moduleId"), []);
  const activityCode = useMemo(() => getParamsFromHash("activityCode"), []);
  const activityId = useMemo(() => getParamsFromHash("activityId"), []);

  // 邀请分享操作
  // const [shareInfo, setShareInfo] = useState({
  //   shareMainTitle: "",
  //   shareSubTitle: "",
  //   shareImgUrl: "",
  //   sharePageUrl: "",
  // });

  const shareParams = useMemo(() => {
    return {
      activityCode: activityCode || "",
      teamCode: infoObj?.selfTeamCode || "",
      shareType: "ranking",
    };
  }, [activityCode, infoObj?.selfTeamCode]);

  const [pageVersionDto, setPageVersionDto] = useState<{
    backUrl?: string;
    versionCode?: string;
    pageCode?: string;
  }>({
    backUrl: "",
  });
  const [moduleJson, setModuleJson] = useState<{
    visual?: {
      prizeSetting?: Array<Record<string, unknown>>;
    };
  }>({});
  const navigate = useNavigate();
  const goHome = async () => {
    const uid = await getCurrentUid();
    if (pageOrigin) {
      // 跳转VIP
      goToPageV2({
        url: `${origin}${PageOriginEnums[pageOrigin]}`,
        params: {
          activityCode: activityCode || "",
          uid,
          ...(["VIP", "VIP_GOODS"].includes(pageOrigin)
            ? {}
            : { pageCode: pageCode || "" }),
        },
        isReplace: true,
      });
    } else {
      navigate(
        `/configPage?activityCode=${activityCode}&pageCode=${pageCode}&uid=${uid}`,
      );
    }
  };
  const getData = useCallback(
    async (type) => {
      const uid = await getCurrentUid();
      // sessionStorage兼容存量活动页； localStorage是因为新版本的跳转方式是新开webview，会导致session丢失
      // const sessionShareInfoObj =
      //   JSON.parse(
      //     sessionStorage?.getItem(`shareInfoObj${pageCode}`) ||
      //       localStorage?.getItem(`shareInfoObj${pageCode}`) ||
      //       "null",
      //   ) || {};
      // if (Object.keys(sessionShareInfoObj).length != 0) {
      //   setShareInfo(sessionShareInfoObj);
      // } else {
      //   goHome();
      // }
      const sessionPageVersionDto =
        JSON?.parse(
          sessionStorage?.getItem(`pageVersionDto${pageCode}`) ||
            localStorage?.getItem(`pageVersionDto${pageCode}`) ||
            "null",
        ) || {};
      console.log(
        "sessionPageVersionDto-------------------",
        sessionPageVersionDto,
      );
      if (Object.keys(sessionPageVersionDto).length != 0) {
        setPageVersionDto(sessionPageVersionDto);
      }
      const sessionPageModuleDto =
        JSON?.parse(
          sessionStorage?.getItem(`pageModuleDto${moduleId}`) ||
            localStorage?.getItem(`pageModuleDto${moduleId}`) ||
            "null",
        ) || {};
      setModuleJson(JSON.parse(sessionPageModuleDto.moduleJson));
      try {
        Loading.show("加载中...");
        const { records } = (await teamMemberList({
          uid,
          activityCode,
        })) as ApiResponse;
        setInfoObj(records[0]);
        setList(records[0]?.memberList || []);
        console.log("%c Line:44 🍬 records", "color:#4fff4B", records);
      } catch (error) {
        console.log("%c Line:114 🥤 error", "color:#b03734", error);
      } finally {
        Loading.hide();
      }
      if (type == "buriedPoint") {
        trackGdp("P20217", "B001", {
          // 页面挂载时埋点
          trackName: "充电_排行榜_我的队伍_页面访问",
          origin: getChannel(),
          activityId: activityId,
        });
      }
    },
    [activityCode, activityId, moduleId, pageCode],
  );
  useEffect(() => {
    // document.title = "我的队伍";
    getData("buriedPoint");
    // TODO 设置假数据
    // setInfoObj(fakeTeamData);
    // setList(fakeTeamData.memberList);
  }, [getData]);
  const infoStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  } as React.CSSProperties;
  // '1' 移除队伍  2'取消'  3'解散'
  const [type, setType] = useState("1");
  const [isDisbandTeam, setIsDisbandTeam] = useState(false);
  const btnThemeColor = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJson?.visual)
      ?.prizeSetting("btnSetting")
      ?.content("btnThemeColor")?.val?.val;
    return result || "";
  }, [moduleJson]);
  const btnAssistColor = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJson?.visual)
      ?.prizeSetting("btnSetting")
      ?.content("btnAssistColor")?.val?.val;
    return result || "";
  }, [moduleJson]);
  const backgroundImage = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJson?.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankMy")?.val?.val;
    return result || moduleJson?.visual?.prizeSetting?.[0]?.content?.[2]?.val;
  }, [moduleJson]);
  // 是否是队长
  const isCaptain = useMemo(() => infoObj?.selfTeamRole == "1", [infoObj]);
  // 是否是队员
  const isTeamMember = useMemo(() => infoObj?.selfTeamRole == "2", [infoObj]);
  // 是否点击 移除按钮
  const isClick_YCDW = useMemo(
    () => isCaptain && type == "2",
    [isCaptain, type],
  );
  const leftStr = useMemo(() => {
    if (isClick_YCDW) {
      return "取消";
    }
    if (isCaptain && type == "1") {
      return "移除成员";
    }
    return "退出";
  }, [isClick_YCDW, isCaptain, type]);
  const titleOrSureStr = useMemo(() => {
    if (isCaptain && isDisbandTeam) {
      return "解散队伍";
    }
    if (isClick_YCDW) {
      return "移除队伍";
    }
    return "退出队伍";
  }, [type, isDisbandTeam]);
  const content = useMemo(() => {
    if (isClick_YCDW) {
      return "是否移除选中的队伍成员？移除后成员的活动值将对应清空";
    }
    if (isCaptain && isDisbandTeam) {
      return "是否解散当前队伍？退出后队伍成员将全部移除";
    }
    return "是否退出当前队伍？退出后队伍活动值将对应清除";
  }, [isClick_YCDW, isCaptain, isDisbandTeam]);
  const leftClick = () => {
    if (isCaptain && type == "1") {
      if (list?.length == 1) {
        return Toast.show({
          content: "暂无可移除成员",
        });
      }
      setType("2");
    }
    if (isClick_YCDW) {
      setType("1");
    }
    if (isTeamMember) {
      PopUpInfoComRef.current?.onOpen();
    }
    trackGdp("P20217", "B002", {
      // 点击埋点
      trackName: "充电_排行榜_我的队伍_按钮点击",
      origin: getChannel(),
      activityId: activityId,
      clickLocation: leftStr,
    });
  };
  const rightStr = useMemo(() => {
    if (isClick_YCDW) {
      return "确认移除";
    }
    return "继续邀请";
  }, [isClick_YCDW]);

  const rightClick = () => {
    if (rightStr == "继续邀请") {
      trackGdp("P20217", "B002", {
        // 点击埋点
        trackName: "充电_排行榜_我的队伍_按钮点击",
        origin: getChannel(),
        activityId: activityId,
        clickLocation: rightStr,
      });
    }
    if (isClick_YCDW) {
      console.log("%c Line:203 🥛 checkValue", "color:#93c0a4", checkValue);
      if (checkValue.length == 0) {
        return Toast.show({
          content: "请先选择要移除的成员",
        });
      }
      return PopUpInfoComRef.current?.onOpen();
    }
    if (Number(infoObj?.peopleCount) >= Number(infoObj?.peopleMax)) {
      return Toast.show({
        content: "已达队伍上限，无法邀请",
      });
    }
    share();
  };
  // 拉起分享
  const share = async () => {
    const userUid = await getCurrentUid();
    const param = {
      ...(shareParams || {}),
      shareUid: userUid || "",
      ...(["VIP", "VIP_GOODS"].includes(pageOrigin)
        ? {}
        : { pageCode: pageCode }),
    };
    let path = `${window.location.origin}${window.location.pathname}#/configPage`;
    if (pageOrigin) {
      path = `${window.location.origin}${PageOriginEnums[pageOrigin]}`;
    }

    const url = appendParamsToUrl(path, param);
    const currentShareParams = {
      shareMainTitle:
        pageVersionDto?.shareTitle ||
        pageVersionDto?.pageTitle ||
        pageVersionDto?.pageName,
      shareSubTitle:
        pageVersionDto?.shareTitle ||
        pageVersionDto?.pageTitle ||
        pageVersionDto?.pageName,
      shareImgUrl: pageVersionDto?.shareUrl || "",
      sharePageUrl: url,
    };
    console.log("当前环境===", getBrowserEnv());
    console.log("isWXApp, isMyApp===", isWXApp, isMyApp);
    console.log("url===", url);
    if (isMyApp || isWXApp) {
      console.log("小程序拉起分享,postMessage 给web-biew");
      console.log("====分享Url===", url);
      defineShareInfoInMiniProgram({
        shareTitle: currentShareParams.shareMainTitle,
        shareIcon: currentShareParams.shareImgUrl || "",
        shareUrl: `/pages/webpage/index?pageUrl=${encodeURIComponent(url)}`,
      });
      console.log(
        "小程序拉起分享url--> ",
        `/pages/webpage/index?pageUrl=${encodeURIComponent(url)}`,
      );
      SharePanelRef?.current?.onOpen({
        sharePageUrl: url,
      });
    } else if (isXPApp) {
      SharePanelRef?.current?.onOpen({
        ...currentShareParams,
        sharePageUrl: url,
      });
    } else {
      SharePanelRef?.current?.onOpen(currentShareParams);
    }
  };
  const jsEvent = () => {
    setIsDisbandTeam(true);
    PopUpInfoComRef?.current?.onOpen();
    trackGdp("P20217", "B002", {
      // 点击埋点
      trackName: "充电_排行榜_我的队伍_按钮点击",
      origin: getChannel(),
      activityId: activityId,
      clickLocation: "解散队伍",
    });
  };
  const onCallback = async () => {
    const uid = await getCurrentUid();
    setTimeout(() => {
      setIsDisbandTeam(false);
    }, 500);

    const handleResponse = (
      res: { code: number; msg: string },
      successMessage: string,
    ) => {
      if (res.code === 200) {
        Toast.show({ content: successMessage });
        return true;
      } else {
        Toast.show({ content: res.msg });
        return false;
      }
    };

    try {
      Loading.show("加载中...");

      if (isCaptain && isDisbandTeam) {
        console.log("%c Line:210 🍣 解散队伍", "color:#b03734");
        const res = await dissolveTeam({
          uid,
          activityCode,
          selfTeamCode: infoObj?.selfTeamCode,
        });
        if (handleResponse(res, "解散成功")) {
          goHome();
        }
      } else if (isClick_YCDW) {
        console.log("%c Line:226 🍷 移除队伍", "color:#ffdd4d");
        const res = await proposer({
          uid,
          activityCode,
          selfTeamCode: infoObj?.selfTeamCode,
          memberUid: checkValue.join(","),
        });
        console.log("%c Line:205 移除队伍🍑 res", "color:#ed9ec7", res);
        if (handleResponse(res, "移除成功")) {
          getData("");
          setType("1");
        }
      } else {
        console.log("%c Line:242 🍔 退出队伍", "color:#7f2b82");
        const res = await dropOutOfLine({
          uid,
          activityCode,
          selfTeamCode: infoObj?.selfTeamCode,
        });
        console.log("%c Line:231 退出队伍🍒 res", "color:#4fff4B", res);
        if (handleResponse(res, "退出成功")) {
          goHome();
        }
      }
    } catch (error) {
      console.log("%c Line:268 🥟 error", "color:#e41a6a", error);
    } finally {
      Loading.hide();
    }
  };
  const onCloseCallback = () => {
    setTimeout(() => {
      setIsDisbandTeam(false);
    }, 500);
  };
  return (
    <PageContainer
      title="我的队伍"
      footerRender={() => (
        <div className={style["footerBox"]}>
          {isNotOver && (
            <div
              className={style["footerBtnLeft"]}
              onClick={leftClick}
              style={{
                backgroundColor: btnAssistColor || "#fff",
                color: btnThemeColor || "#333",
                borderColor: btnThemeColor || "#333",
              }}
            >
              {leftStr}
            </div>
          )}
          {isNotOver && (
            <div
              className={style["footerBtnRight"]}
              onClick={rightClick}
              style={{
                backgroundColor: btnThemeColor || "#333",
                color: btnAssistColor || "#fff",
              }}
            >
              {rightStr}
            </div>
          )}
        </div>
      )}
    >
      <div
        className={style["myTeamBox"]}
        style={{
          backgroundImage: `url(${processOssImage(backgroundImage)})`,
          backgroundSize: "100%",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className={style["teamInfoBox"]}>
          <div className={style["teamInfoBoxTop"]}>
            <div>{infoObj?.selfTeamName}</div>
            {isNotOver && isCaptain && (
              <div
                className={style["jsBtn"]}
                onClick={jsEvent}
                style={{
                  borderColor: btnThemeColor || "#333",
                  backgroundColor: btnAssistColor || "#FFF",
                  color: btnThemeColor || "#333",
                }}
              >
                解散队伍
              </div>
            )}
          </div>
          <div className={style["teamInfoBoxBottom"]}>
            <div style={infoStyle}>
              <div style={{ marginBottom: "10px" }}>
                {infoObj?.selfTeamActivityValue}
              </div>
              <div className={style["smallFont"]}>队伍{hdFontVal}</div>
            </div>
            <div style={infoStyle} className={style["middleBox"]}>
              <div style={{ marginBottom: "10px" }}>
                {infoObj?.selfTeamActivityRank}
              </div>
              <div className={style["smallFont"]}>队伍排名</div>
            </div>
            <div style={infoStyle}>
              <div style={{ marginBottom: "10px" }}>
                {infoObj?.peopleCount}/{infoObj?.peopleMax}
              </div>
              <div className={style["smallFont"]}>成员数</div>
            </div>
          </div>
        </div>
        <div className={style["teamListBox"]}>
          <Checkbox.Group
            value={checkValue}
            onChange={(val) => {
              setCheckValue(val as string[]);
            }}
          >
            {list?.map((item, i) => (
              <div className={style["teamList"]} key={i}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isClick_YCDW && item.memberTeamRole == "2" && (
                    <Checkbox value={item.memberUid} style={{ zoom: 1.5 }} />
                  )}
                  <div className={style["memberName"]}>
                    {item.memberUserName}
                  </div>
                  {item.memberTeamRole == "1" && (
                    <div className={style["captain"]}>
                      {item.memberTeamRoleCn}
                    </div>
                  )}
                </div>
                <div>
                  {hdFontVal}: {item.memberActivityValue}
                </div>
              </div>
            ))}
          </Checkbox.Group>
        </div>
      </div>
      <PopUpInfoCom
        title={titleOrSureStr}
        isNeedCloseBtn={true}
        sureBtnStr={titleOrSureStr}
        content={content}
        ref={PopUpInfoComRef}
        onCallback={onCallback}
        onCloseCallback={onCloseCallback}
      />
      <SharePanel
        ref={SharePanelRef}
        onClose={() => {
          trackGdp("P20189", "B002", {
            trackName: "充电_营销专题页_页面分享",
            origin: getChannel(),
            userType: "",
            versionId: pageVersionDto.versionCode,
            pageId: pageVersionDto.pageCode,
          });
        }}
      />
    </PageContainer>
  );
};

export default ActivityDetail;
